import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FeatureFlagsEffects } from './store/feature-flags-effects';
import { FeatureFlagNamespace, FeatureFlagReducer } from './store/feature-flags.store';

@NgModule({
  imports: [
    StoreModule.forFeature(FeatureFlagNamespace, FeatureFlagReducer),
    EffectsModule.forFeature([FeatureFlagsEffects]),
  ],
})
export class FeatureFlagsDataModule {}
